import { Dialog } from '../../../../../components';

function CancelAssignedPopup({ handleClose, handleConfirm }) {
  return (
    <Dialog
      handleClose={handleClose}
      handleCancel={handleClose}
      handleConfirm={handleConfirm}
      open={true}
      title="Cancel Assignd Ward & Re-assign"
      cancel="Cancel"
      confirm="Confirm"
    >
      <div>Do you confirm to cancel the assigned ward & re-assign again?</div>
      <div>After clicking confirm, previous ward assignment history will be removed</div>
    </Dialog>
  );
}

export default CancelAssignedPopup;
